import React, { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import * as FiIcons from 'react-icons/fi';
const { FiDollarSign, FiX, FiArrowRight, FiZap } = FiIcons;

const LS_KEY = 'aff_banner_dismissed_v1';

export default function AffiliateBanner() {
  const { setCurrentPage } = useAppContext();
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(LS_KEY) === 'true'; } catch { return false; }
  });

  if (dismissed) return null;

  const dismiss = () => {
    setDismissed(true);
    try { localStorage.setItem(LS_KEY, 'true'); } catch {}
  };

  return (
    <div className="fixed bottom-20 right-4 z-30 max-w-[280px] animate-slide-up">
      <div className="relative rounded-2xl p-4"
        style={{ background: 'rgba(8,0,18,0.98)', border: '1px solid rgba(255,0,200,0.4)', boxShadow: '0 0 30px rgba(255,0,200,0.15)' }}>
        <button onClick={dismiss}
          className="absolute top-2 right-2 w-6 h-6 rounded-md bg-white/10 hover:bg-white/20 text-gray-500 hover:text-white flex items-center justify-center transition-all">
          <FiX className="text-xs" />
        </button>
        <div className="flex items-center gap-2 mb-2">
          <div className="w-8 h-8 rounded-lg flex items-center justify-center shrink-0"
            style={{ background: 'linear-gradient(135deg,#ff00cc,#cc00ff)' }}>
            <FiDollarSign className="text-white text-sm" />
          </div>
          <div>
            <div className="font-black text-white text-sm uppercase tracking-wider">Earn 20%</div>
            <div className="text-gray-500 text-[11px]">Refer friends, get paid</div>
          </div>
        </div>
        <p className="text-gray-400 text-xs mb-3 leading-relaxed">
          Share your link. Earn <span className="text-pink-400 font-black">20% commission</span> on every pixel sale you refer.
        </p>
        <button onClick={() => { setCurrentPage('affiliate'); dismiss(); }}
          className="w-full py-2 rounded-xl font-black text-xs uppercase tracking-wider text-white flex items-center justify-center gap-1.5 transition-all hover:scale-[1.02]"
          style={{ background: 'linear-gradient(135deg,#ff00cc,#cc00ff)' }}>
          <FiZap className="text-xs" /> Get My Link <FiArrowRight className="text-xs" />
        </button>
      </div>
    </div>
  );
}